import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createSecurity,
  listSecurities,
  updateSecurity,
  type CreateSecurityInput,
} from "./api";

const KEY = ["securities"];

export const useSecurities = () => useQuery({ queryKey: KEY, queryFn: listSecurities });

export function useCreateSecurity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateSecurityInput) => createSecurity(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateSecurity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: string; patch: Partial<CreateSecurityInput> & { status?: string } }) =>
      updateSecurity(id, patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
